module.exports = __webpack_public_path__ + "static/media/homes.3fee0d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/homes.jpg
// module id = 434
// module chunks = 0